/*
 *
 * OrganizationPage actions
 *
 */

import {
  CLEAR_TABLE_WATCHER,
  CLEAR_TABLE_SUCCEESS,
  TOGGLE_CREATE_MODAL,
  GET_MEDITIONS_ORGANIZATION,
  GET_MEDITIONS_ORGANIZATION_WATCHER,
  SUBMIT_FEEDBACK_SURVEY_WATCHER,
  DISMISS_FEEDBACK_SURVEY_WATCHER,
  GET_VISMA_PEOPLE_STATUS_WATCHER,
  GET_VISMA_PEOPLE_STATUS_SUCCESS,
  GET_VISMA_PEOPLE_STATUS_FAILED,
} from "./constants"

export function clearTableWatcher() {
  return { type: CLEAR_TABLE_WATCHER }
}

export function clearTableSuccess() {
  return { type: CLEAR_TABLE_SUCCEESS }
}

export function toggleCreateModal(payload) {
  return {
    type: TOGGLE_CREATE_MODAL,
    payload,
  }
}

export function getMeditions(payload) {
  return {
    type: GET_MEDITIONS_ORGANIZATION_WATCHER,
    payload,
  }
}

export function getMeditionsSuccess(payload) {
  return {
    type: GET_MEDITIONS_ORGANIZATION,
    payload,
  }
}

export function submitFeedbackSurvey(payload) {
  return {
    type: SUBMIT_FEEDBACK_SURVEY_WATCHER,
    payload,
  }
}

export function dismissFeedbackSurvey() {
  return {
    type: DISMISS_FEEDBACK_SURVEY_WATCHER,
  }
}

export function getVismaPeopleStatusWatcher(payload) {
  return {
    type: GET_VISMA_PEOPLE_STATUS_WATCHER,
    payload,
  }
}

export function getVismaPeopleStatusSuccess(payload) {
  return {
    type: GET_VISMA_PEOPLE_STATUS_SUCCESS,
    payload,
  }
}

export function getVismaPeopleStatusFailed(payload) {
  return {
    type: GET_VISMA_PEOPLE_STATUS_FAILED,
    payload,
  }
}